<top-banner variant="logo"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">

    <!-- All Sites -->
    <div class="cards-flex-row">
      <dashboard-card style="flex: 2" title="All Sites" [loading]="allSitesSummary.loading">
        <div class="large-number-display-wrapper">
          <large-number-display
              [number]="allSitesSummary.workOrderSessions.length"
              [text]="'open work order' | plural: allSitesSummary.workOrderSessions.length"
              [class]="allSitesSummary.workOrderSessions.length > 0 ? 'green' : 'green disabled'"
              (onClick)="allSitesSummary.workOrderSessions.length > 0 ? openWorkOrdersModalFromSessions(allSitesSummary.workOrderSessions) : false">
          </large-number-display>
          <large-number-display
              [number]="allSitesSummary.siteSessions.length"
              [text]="'site session' | plural: allSitesSummary.siteSessions.length"
              [class]="allSitesSummary.siteSessions.length > 0 ? 'blue' : 'blue disabled'"
              (onClick)="allSitesSummary.siteSessions.length > 0 ? openSessionsModal(allSitesSummary.siteSessions) : false">
          </large-number-display>
          <large-number-display
              [number]="allSitesSummary.workers.length"
              [text]="('active worker' | plural: allSitesSummary.workers.length) + (' and ' + allSitesSummary.guestCount + ' guest' | plural: allSitesSummary.guestCount)"
              [class]="allSitesSummary.workers.length > 0 ? 'default' : 'default disabled'"
              (onClick)="allSitesSummary.workers.length > 0 ? openSessionsModal(allSitesSummary.workers) : false">
            </large-number-display>
          </div>
          <a class="under-row" [routerLink]="['/' + routeRole, 'sites']">manage sites</a>
          <a class="under-row" [routerLink]="['/' + routeRole, 'work-orders']">view all work orders</a>
        </dashboard-card>

        <dashboard-card style="flex: 1" [loading]="allSitePendingWorkOrders.loading">
          <h5 class="card-title">
            <i *ngIf="allSitePendingWorkOrders.workOrders.length" class="fa fa-exclamation-triangle warning"></i>
            Approvals
          </h5>
          <div class="large-number-display-wrapper justify-space-around">
            <large-number-display
            style="flex: 1; text-align: center;"
            [number]="allSitePendingWorkOrders.workOrders.length"
            [text]="'pending approval'"
            [class]="allSitePendingWorkOrders.workOrders.length ? 'yellow' : 'green-outline disabled'"
              (onClick)="allSitePendingWorkOrders.workOrders.length ? openWorkOrdersModal(allSitePendingWorkOrders.workOrders) : false">
          </large-number-display>
        </div>
        <a class="under-row" [routerLink]="['/' + routeRole, 'work-orders']">view all work orders</a>
      </dashboard-card>

      <dashboard-card style="flex: 2" [loading]="healthChecksInfo.loading">
        <h5 class="card-title">
          <i *ngIf="healthChecksInfo.healthChecksDue.length" class="fa fa-exclamation-triangle warning"></i>
          Waypoints Due
        </h5>
        <div class="large-number-display-wrapper justify-space-around">
          <large-number-display
              style="flex: 1; text-align: center;"
              [number]="healthChecksInfo.healthChecksDue.length"
              [class]="healthChecksInfo.healthChecksDue.length ? 'yellow' : 'green-outline disabled'"
              (onClick)="healthChecksInfo.healthChecksDue.length ? navigateToLiveSessions({ tab: 'list', waypoint: 'Overdue' }) : false">
          </large-number-display>
          <overdue-health-check-list
              style="flex: 2"
              [healthChecks]="healthChecksInfo.healthChecksDue"
              emptyStateText="No waypoints due"></overdue-health-check-list>
        </div>
        <a class="under-row" [routerLink]="['/' + routeRole, 'live-sessions']" [queryParams]="{ tab: 'list', waypoint: 'Overdue'  }">go to live sessions</a>
      </dashboard-card>
      <dashboard-card style="flex: 2" [loading]="healthChecksInfo.loading">
        <h5 class="card-title">
          <i *ngIf="healthChecksInfo.expectedCheckOffTimesDue.length" class="fa fa-exclamation-triangle warning"></i>
          Expected Check Off Times Due
        </h5>
        <div class="large-number-display-wrapper justify-space-around">
          <large-number-display
              style="flex: 1; text-align: center;"
              [number]="healthChecksInfo.expectedCheckOffTimesDue.length"
              [class]="healthChecksInfo.expectedCheckOffTimesDue.length ? 'yellow' : 'green-outline disabled'"
              (onClick)="healthChecksInfo.expectedCheckOffTimesDue.length ? navigateToLiveSessions({ tab: 'list', checkOffTime: 'Overdue' }) : false">
          </large-number-display>
          <overdue-health-check-list
              style="flex: 2"
              [healthChecks]="healthChecksInfo.expectedCheckOffTimesDue"
              emptyStateText="No expected check-offs due"></overdue-health-check-list>
        </div>
        <a class="under-row" [routerLink]="['/' + routeRole, 'live-sessions']" [queryParams]="{ tab: 'list', checkOffTime: 'Overdue' }">go to live sessions</a>
      </dashboard-card>
    </div>

    <!-- Admin and Support -->
    <ng-container *ngIf="!isSiteOwnerOrDelegate">

      <h6 class="cards-flex-row-header mt-5">Admin and support</h6>
      <div class="cards-flex-row mb-5">
        <div class="d-flex flex-column">
          <p>Due to the number of sites admin users can view, the following section is set to only load when requested.</p>
          <p *ngIf="adminLastLoadTime">Last loaded: {{ adminLastLoadTime | date: 'medium' }}</p>

            <div class="button-group">
              <button class="btn btn-primary" (click)="loadSitesForAdmin()">Load</button>
            </div>
        </div>
      </div>

    </ng-container>

    <h6 class="cards-flex-row-header mt-2">Sites</h6>
    <!-- Filtering -->
    <div class="filter-flex-row dashboard">
      <text-filter-box (onFilterTextChanged)="onFilterTextChanged($event)"></text-filter-box>
    </div>

    <!-- Each Site -->
    <p *ngIf="!sites.length" class="cards-flex-row-paragraph">No sites</p>
    <p *ngIf="sites.length && !filteredSites.length" class="cards-flex-row-paragraph">No sites match the filter</p>
    <ng-container *ngFor="let site of filteredSites">
      <h4 class="cards-flex-row-header">{{site.name}}</h4>

      <div class="cards-flex-row">

        <!-- Work orders chart -->
        <dashboard-card title="Work Orders" [loading]="workOrderGraphDataGroupedBySite.loading">
          <!-- main -->
          <div class="d-flex flex-column justify-content-center" *ngIf="workOrderGraphDataGroupedBySite[site.id]">
            <work-order-bar-graph [workOrders]="workOrderGraphDataGroupedBySite[site.id]"></work-order-bar-graph>
          </div>
          <!-- loading first time -->
          <div class="d-flex flex-column justify-content-between" *ngIf="workOrderGraphDataGroupedBySite.loading && !workOrderGraphDataGroupedBySite[site.id]">
            <p>loading...</p>
          </div>
          <!-- no work orders -->
          <div class="d-flex flex-column justify-content-between" *ngIf="!workOrderGraphDataGroupedBySite.loading && !workOrderGraphDataGroupedBySite[site.id]">
            <p>No work orders</p>
          </div>
          <a class="under-row" [routerLink]="['/' + routeRole, 'sites', site.id, 'work-orders']">view work orders</a>
        </dashboard-card>

        <!-- Assets -->
        <dashboard-card class="flex-small" title="Assets">
          <!-- main -->
          <div class="d-flex flex-column justify-content-between" *ngIf="site.countAssets > 0" >
            <div>
              <p>
                <i class="fa fa-layer-group"></i>
                {{ site.countAssets }} total {{'asset' | plural: site.countAssets }}
              </p>
              <p>
                <i class="fa fa-unlock success"></i>
                {{ site.countUnlockedAssets }} unlocked
              </p>
              <p>
                <i class="fa fa-lock danger"></i>
                {{ site.countLockedAssets }} locked
              </p>
            </div>
            <p *ngIf="site.countExpiredCertificates > 0" class="asset-restriction">
              <i class="fa fa-exclamation-triangle"></i>
              {{ site.countExpiredCertificates }} {{ 'asset' | plural: site.countExpiredCertificates }} with expired certificates
            </p>
            <p *ngIf="site.countSurrendered" class="asset-restriction">
              <i class="fa fa-exclamation-triangle"></i>
              {{ site.countSurrendered }} {{ 'asset' | plural: site.countSurrendered }} locked by a surrendered work order
            </p>
          </div>
          <!-- site has no assets -->
          <div class="d-flex flex-column justify-content-between" *ngIf="site.countAssets == 0">
            <p>No Assets</p>
          </div>
          <a class="under-row" [routerLink]="['/' + routeRole, 'sites', site.id, 'assets']">view assets</a>
        </dashboard-card>

        <!-- Inductions -->
        <dashboard-card class="flex-small" title="Workers ">
          <div class="d-flex flex-column justify-content-between">
            <!-- main -->
            <div *ngIf="site.hasInduction">
              <p>
                <i class="fa fa-users"></i>
                {{site.countWorkerUsers}} total {{'worker' | plural: site.countWorkerUsers }}
              </p>
              <p>
                <i class="fa fa-check success"></i>
                {{site.countValidInductions}} valid site {{'induction' | plural: site.countValidInductions }}
              </p>
              <p>
                <i class="fa fa-times danger"></i>
                {{ site.countInvalidInductions }} missing site {{'induction' | plural: site.countInvalidInductions }}
              </p>
            </div>
            <!-- doesn't have induction -->
            <div *ngIf="!site.hasInduction">
              <p>Site doesn't require an induction</p>
            </div>
            <!-- expired competencies -->
            <p *ngIf="site.countExpiredCompetencies > 0" class="asset-restriction">
              <i class="fa fa-exclamation-triangle"></i>
              {{site.countExpiredCompetencies}} {{site.countExpiredCompetencies > 1 ? 'competencies' : 'competency'}} expired
            </p>
          </div>
          <a class="under-row" [routerLink]="['/' + routeRole, 'sites', site.id, 'workers']">view workers</a>
        </dashboard-card>

        <!-- Workers -->
        <dashboard-card title="Workers On Site" [loading]="sessionsGroupedBySite.loading">
          <!-- loading first time -->
          <div class="d-flex flex-column justify-content-between" *ngIf="sessionsGroupedBySite.loading && !sessionsGroupedBySite[site.id]">
            <p>loading...</p>
          </div>
          <!-- main -->
          <div class="d-flex flex-column justify-content-between" *ngIf="sessionsGroupedBySite[site.id]">
            <div class="large-number-display-wrapper">
              <large-number-display
                  [number]="sessionsGroupedBySite[site.id].workersCheckedOnToWorkOrders.length"
                  [text]="'checked on to work orders'"
                  [class]="sessionsGroupedBySite[site.id].workersCheckedOnToWorkOrders.length > 0 ? 'green-outline' : 'green-outline disabled'"
                  (onClick)="sessionsGroupedBySite[site.id].workersCheckedOnToWorkOrders.length > 0 ? openSessionsModal(sessionsGroupedBySite[site.id].workersCheckedOnToWorkOrders): false">
              </large-number-display>
              <large-number-display
                  [number]="sessionsGroupedBySite[site.id].siteSessions.length"
                  [text]="'checked on to site'"
                  [class]="sessionsGroupedBySite[site.id].siteSessions.length > 0 ? 'blue' : 'blue disabled'"
                  (onClick)="sessionsGroupedBySite[site.id].siteSessions.length > 0 ? openSessionsModal(sessionsGroupedBySite[site.id].siteSessions): false">
              </large-number-display>
            </div>
            <p>and {{sessionsGroupedBySite[site.id].guestCount}} {{'guest' | plural: sessionsGroupedBySite[site.id].guestCount}}</p>
          </div>
          <!-- no sessions for this site -->
          <div class="d-flex flex-column justify-content-between" *ngIf="!sessionsGroupedBySite.loading && !sessionsGroupedBySite[site.id]">
            <div class="large-number-display-wrapper">
              <large-number-display [number]="0" [text]="'checked on to work orders'" [class]="'green-outline disabled'"></large-number-display>
              <large-number-display [number]="0" [text]="'checked on to site'" [class]="'blue disabled'"></large-number-display>
            </div>
            <p>and 0 guests</p>
          </div>
          <a class="under-row" [routerLink]="['/' + routeRole, 'sites', site.id, 'work-orders']">view work orders</a>
          <a class="under-row" [routerLink]="['/' + routeRole, 'live-sessions']" [queryParams]="{ tab: 'list' }">view live sessions</a>
        </dashboard-card>
      </div>

    </ng-container>

  </div>
</div>
